<template>
  <div class="chart-container">
    <canvas ref="accountChart"></canvas>
  </div>
</template>

<script>
import { Chart } from 'chart.js/auto'

export default {
  name: 'AccountStatusChart',
  mounted() {
    const ctx = this.$refs.accountChart.getContext('2d')

    new Chart(ctx, {
      type: 'bar',
      data: {
        labels: ['January', 'February', 'March', 'April', 'May', 'June'],
        datasets: [
          {
            label: 'Retention',
            data: [120, 140, 160, 180, 200, 220],
            backgroundColor: '#42A5F5' // Blue
          },
          {
            label: 'Cancellations',
            data: [30, 40, 35, 45, 50, 55],
            backgroundColor: '#EF5350' // Red
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          title: {
            display: true,
            text: 'Account Retention vs Cancellation (Jan – Jun)',
            font: { size: 16 }
          },
          legend: {
            position: 'top'
          }
        },
        scales: {
          x: {
            title: {
              display: true,
              text: 'Month'
            },
            stacked: false // adjacent, not stacked
          },
          y: {
            beginAtZero: true,
            title: {
              display: true,
              text: 'Number of Accounts'
            }
          }
        }
      }
    })
  }
}
</script>

<style scoped>
.chart-container {
  width: 100%;
  height: 60vh;
  padding: 1rem;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

canvas {
  width: 100% !important;
  height: 100% !important;
}
</style>